import React from 'react'
import Typography from '../Typography'
import classes from './dress-code-info.module.sass'

const DressCodeInfo = ({
  school: {
    whatToWear,
    girlsDressCode,
    boysDressCode,
    seniorSessionInformation,
    seniorSessionExtraInformation,
  },
}) => (
  <>
    {whatToWear && (
      <>
        <Typography weight="bold" classes={classes.header}>What to wear:</Typography>
        {whatToWear && <Typography>{whatToWear}</Typography>}
        {girlsDressCode && <Typography>{girlsDressCode}</Typography>}
        {boysDressCode && <Typography>{boysDressCode}</Typography>}
      </>
    )}
    {(seniorSessionInformation || seniorSessionExtraInformation) && (
      <>
        <Typography weight="bold" classes={classes.header}>Additional info:</Typography>
        {seniorSessionInformation && <Typography>{seniorSessionInformation}</Typography>}
        {seniorSessionExtraInformation && <Typography>{seniorSessionExtraInformation}</Typography>}
      </>
    )}
  </>
)

export default DressCodeInfo
